import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import apiManagerStorage from 'api/manager-storage';
import { IconClose } from 'assets/icons';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { RESPONSE_CODE_STORAGE } from 'pages/manager-storage/components/constant';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC, toastError, toastSuccess, toastWarning } from 'utils/helpers';
import { DIALOG_ID } from './constant';

const DialoginviteUseSharedStorage = () => {
    const inviteUsingSharedStorage = (emailUser) => {
        return apiManagerStorage.inviteUsingSharedStorage({ inviteeEmail: emailUser });
    }

    const { t } = useTranslation("pgStorage");
    const [email, setEmail] = useState("");
    const [submit, setSubmit] = useState(false);
    const [validValue, setValidValue] = useState({ result: false, text: t('validate.email.required') });
    const propsDialog = useLegacyDialogProps();
    const { action } = propsDialog;

    const isValidMail = (string) => {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/mig
        return re.test(string)
    }

    const handleValidEmail = (value) => {
        if (!value) {
            setValidValue({ result: false, text: ('validate.email.required') });
        } else if (value?.length > 320) {
            setValidValue({ result: false, text: ('validate.email.maxText') });
        } else if (!isValidMail(value)) {
            setValidValue({ result: false, text: ('validate.email.mailFormat') });
        } else {
            setValidValue({ result: true, text: '' });
        }
    }

    const handleCancel = () => {
        setCloseDialogCC();
        setEmail("");
        setValidValue({ result: false, text: ('validate.email.required') });
        setSubmit(false);
    }
    const handleSubmit = () => {
        !submit && setSubmit(true);
        if (!validValue?.result) {
            return;
        }

        inviteUsingSharedStorage(email)
            .then(result => {
                toastSuccess(t("toast.invite-success"));
                setEmail("");
                setValidValue({ result: false, text: ('validate.email.required') });
                setSubmit(false);
                setCloseDialogCC();
                action();
            })
            .catch(error => {
                switch (error.response.data?.code) {
                    case RESPONSE_CODE_STORAGE.Email_not_exit:
                        toastError(t("toast.email-not-existed"));
                        break;
                    case RESPONSE_CODE_STORAGE.Not_enough_space_to_invite:
                        toastError(t("toast.not-enough-space-to-invite"));
                        break;
                    case RESPONSE_CODE_STORAGE.Inviter_has_been_invited:
                        toastWarning(t("toast.inviter-has-been-invited"));
                        break;
                    case RESPONSE_CODE_STORAGE.Using_shared_storage:
                        toastError(t("toast.using-shared-storage"));
                        break;
                    case RESPONSE_CODE_STORAGE.Not_invite_your_self:
                        toastError(t("toast.not-invite-your-self"));
                        break;
                    default:
                        toastError(t('toast.errorServer'));
                        break;
                }
            })
    }

    return (
        <DialogBaseCC id={DIALOG_ID.INVITE_USE_SHARED_STORAGE} title={t('dialog.invite-use-shared-storage.title')} customClose={handleCancel}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ marginBottom: '1rem' }}>
                        <Typography>{t('dialog.invite-use-shared-storage.content')}</Typography>
                        <Typography></Typography>
                    </Box>
                    <Box>
                        <TextField
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value.trim());
                                handleValidEmail(e.target.value.trim());
                            }}
                            autoFocus
                            fullWidth
                            error={submit && !validValue?.result}
                            helperText={submit && t(validValue?.text)}
                            placeholder={t('dialog.invite-use-shared-storage.placeholder')}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {email.length > 0 ? (
                                            <IconButton
                                                tabIndex={-1}
                                                aria-label="toggle oldPassword visibility"
                                                onClick={() => setEmail("")}
                                                sx={{ p: 0.5 }}
                                            >
                                                <IconClose />
                                            </IconButton>
                                        ) : (
                                            <></>
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleCancel}>{t('dialog.invite-use-shared-storage.button.cancel')}</Button>
                <Button onClick={handleSubmit}>{t('dialog.invite-use-shared-storage.button.save')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialoginviteUseSharedStorage
